<template>
    <Head title="Users"/>

    <h1 class="mt-2 text-2xl font-bold leading-7 text-gray-900 sm:text-3xl sm:truncate">
        Users
    </h1>

    <div class="bg-white py-6 px-4 mt-4 sm:p-6 shadow">
        <div class="flex justify-end">
            <div>
                <select id="transaction-type" v-model="form.filters.status"
                    class="block w-full bg-white border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-gray-900 focus:border-gray-900 sm:text-sm">
                    <option value selected v-html="'Please Select'"></option>
                    <option value="active">Active</option>
                    <option value="archived">Archived</option>
                </select>
            </div>
            <search-filter :show-filter="false" v-model:value="form.filters.search" class="w-1/4 max-w-md mr-4"
                           @reset="reset"></search-filter>
            <Button v-on:click="toggleUserSlideout(null)"
                    class="inline-flex items-center px-3 py-2 border border-transparent shadow-sm text-sm leading-4 rounded-md text-white bg-pitch-purple focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-amaze-coral">
                <svg class="-ml-0.5 mr-2 h-4 w-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                     stroke="currentColor" aria-hidden="true">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                          d="M12 9v3m0 0v3m0-3h3m-3 0H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                </svg>
                Add New User
            </Button>
        </div>
        <div class="flex flex-col mt-3 space-y-3">
            <div class="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
                <div class="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
                    <div class="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
                        <table class="min-w-full divide-y divide-gray-200">
                            <thead class="bg-gray-50">
                            <tr>
                                <th scope="col"
                                    class="px-6 py-3 text-left text-xs text-gray-500 uppercase tracking-wider">
                                    Name
                                </th>
                                <th scope="col"
                                    class="px-6 py-3 text-left text-xs text-gray-500 uppercase tracking-wider">
                                    Code
                                </th>

                                <th scope="col"
                                    class="px-6 py-3 text-left text-xs text-gray-500 uppercase tracking-wider">
                                    Job Title
                                </th>
                                <th scope="col"
                                    class="px-6 py-3 text-left text-xs text-gray-500 uppercase tracking-wider">
                                    Telephone
                                </th>
                                <th scope="col"
                                    class="px-6 py-3 text-left text-xs text-gray-500 uppercase tracking-wider">
                                    Mobile
                                </th>
                                <th scope="col"
                                    class="px-6 py-3 text-left text-xs text-gray-500 uppercase tracking-wider">
                                    Email
                                </th>
                                <th scope="col"
                                    class="px-6 py-3 text-left text-xs text-gray-500 uppercase tracking-wider">
                                    Role
                                </th>
                                <th scope="col" class="relative px-6 py-3"></th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-if="users.data.length > 0" v-for="(user, index) in users.data" :key="index"
                                :class="{'bg-gray-100': index % 2}" class="hover:bg-gray-50 cursor-pointer">
                                <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900"
                                    @click="toggleUserSlideout(user)">
                                    {{ user.name }}
                                </td>
                                <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                    {{ user.code }}
                                </td>

                                <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                    {{ user.job_title }}
                                </td>
                                <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                    {{ user.telephone }}
                                </td>
                                <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                    {{ user.mobile }}
                                </td>
                                <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                    {{ user.email }}
                                </td>
                                <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                    {{ user.role }}
                                </td>
                                <td>
                                    <button v-if="user.deleted_at" type="button" @click="restore(user)" class="inline-flex items-center px-2.5 py-0.5 rounded-md text-xs font-medium shadow-md bg-dark-pitch-purple text-white">
                                        Restore <ArchiveIcon class="h-4 w-4 my-auto ml-2" aria-hidden="true"/>
                                    </button>
                                    <button v-else-if="!user.deleted_at" type="button" @click="archive(user)" class="inline-flex items-center px-2.5 py-0.5 rounded-md text-xs font-medium shadow-md bg-dark-pitch-purple text-white">
                                        Archive <ArchiveIcon class="h-4 w-4 my-auto ml-2" aria-hidden="true"/>
                                    </button>
                                </td>
                            </tr>
                            <tr v-else>
                                <td colspan="8" class="px-6 py-4 whitespace-nowrap text-sm text-gray-900 bg-gray-100">
                                    There are no users available for your search criteria.
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <Pagination :links="users.links"/>
        </div>
    </div>

    <CreateUser ref="createUserSlideout"/>

</template>


<script>

import Authenticated from "@/Layouts/Authenticated";
import {Head, router} from "@inertiajs/vue3";
import Pagination from "@/Components/Pagination";
import SearchFilter from "@/Components/SearchFilter";
import debounce from 'lodash/debounce'
import pickBy from 'lodash/pickBy'
import mapValues from 'lodash/mapValues'
import CreateUser from "@/Components/SlideOuts/CreateUser";
import Button from "@/Components/Button";
import {ArchiveIcon} from '@heroicons/vue/outline'
import axios from "axios";

export default {
    layout: Authenticated,
    components: {
        Button,
        CreateUser,
        Pagination,
        Head,
        SearchFilter,
        ArchiveIcon,
    },
    props: {
        users: Object,
        roles: Object,
        trading_details: Object,
        status: String,
    },
    data() {
        return {
            form: {
                filters: {
                    search: null,
                    status: this.status ? this.status : 'active',
                }
            }
        }
    },
    methods: {
        reset() {
            this.form.filters.search = null;
        },
        toggleUserSlideout(user = null) {
            this.$refs.createUserSlideout.updating = user !== null;
            this.$refs.createUserSlideout.roles = this.roles;
            this.$refs.createUserSlideout.trading_details = this.trading_details;
            this.$refs.createUserSlideout.form.id = user !== null ? user.id : null
            this.$refs.createUserSlideout.form.first_name = user !== null ? user.first_name : null
            this.$refs.createUserSlideout.form.credit_card_name = user !== null ? user.credit_card_name : null
            this.$refs.createUserSlideout.form.last_name = user !== null ? user.last_name : null
            this.$refs.createUserSlideout.form.code = user !== null ? user.code : null
            this.$refs.createUserSlideout.form.job_title = user !== null ? user.job_title : null
            this.$refs.createUserSlideout.form.telephone = user !== null ? user.telephone : null
            this.$refs.createUserSlideout.form.mobile = user !== null ? user.mobile : null
            this.$refs.createUserSlideout.form.email = user !== null ? user.email : null
            this.$refs.createUserSlideout.form.role = user !== null ? user.role : null
            this.$refs.createUserSlideout.form.trading_details = user !== null ? user.trading_details : null
            this.$refs.createUserSlideout.open();
        },
        archive(user) {
            this.$swal.fire({
                title: 'Archive User',
                html: "You are archiving a user: " + user.name + ". <br/>Are you sure you'd like to do this?",
                showCloseButton: true,
                showCancelButton: true,
                confirmButtonText: 'Yes',
                cancelButtonText: 'No'
            })
            .then((result) => {
                if (result.isConfirmed) {
                    // Soft delete user
                    router.patch(route('admin.users.user.delete', user.id), {
                        onSuccess: page => {}
                    });
                }
            });
        },
        restore(user) {
            this.$swal.fire({
                title: 'Restore User',
                html: "You are restoring a user: " + user.name + ". <br/>Are you sure you'd like to do this?",
                showCloseButton: true,
                showCancelButton: true,
                confirmButtonText: 'Yes',
                cancelButtonText: 'No'
            })
            .then((result) => {
                if (result.isConfirmed) {
                    // Restore archived user
                    router.patch(route('admin.users.user.restore', user.id), {
                        onSuccess: page => {}
                    });
                }
            });
        }
    },
    watch: {
        form: {
            deep: true,
            handler: debounce(function () {
                this.$inertia.get(route('admin.users.index'), pickBy(this.form), {preserveState: true})
            }, 500),
        },
    },
}
</script>
